import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'greydom-obd-capture-placeholder',
  templateUrl: './obd-capture-placeholder.component.html',
  styleUrls: ['./obd-capture-placeholder.component.scss']
})
export class ObdCapturePlaceholderComponent {

  @Input() headerText: string;
  @Input() subtext: string;
  @Input() buttonText = 'Capture Details';
  @Output() onClick = new EventEmitter<void>();

  constructor(public dialog: MatDialog) {
  }

  onClickButton(): void {
    this.onClick.emit();
  }

}
